module.exports = __webpack_public_path__ + "img/asuransi-motor.9f9d2d07.svg";